
export { getTrailDifficultyLabelFromNumber } from "/app/packages/trails/src/utils/trailDifficultyHelpers.ts"
export { default as trailFromAlgoliaTrail } from "./utils/trailFromAlgoliaTrail"